import { defineComponent as k, ref as g, computed as T, watch as S, createElementBlock as s, openBlock as d, normalizeStyle as p, normalizeClass as n, unref as t, createCommentVNode as o, createElementVNode as r, withDirectives as B, renderSlot as i, createStaticVNode as E, createVNode as h, vShow as C } from "vue";
import { useResizeObserver as I, useMediaQuery as y } from "@vueuse/core";
import { EDITOR_ID as P, DocumentClasses as c, EditorClasses as N } from "@scalar-org/css";
import V from "./components/PageNav.vue.js";
import "./components/PageNav.vue2.js";
import D from "./components/TableOfContents.vue.js";
const G = ["id"], z = {
  key: 0,
  class: "layout-header"
}, O = {
  key: 1,
  class: "layout-aside-content"
}, R = ["id"], L = { class: "layout-aside-right" }, M = { class: "layout-footer" }, J = /* @__PURE__ */ k({
  __name: "ApiGuide",
  props: {
    activePage: {},
    editorViewportId: {},
    showSidebar: { type: Boolean },
    footerBelowSidebar: { type: Boolean },
    sidebar: {},
    headings: {},
    isLoaded: { type: Boolean }
  },
  emits: ["goToNextPage", "goToPrevPage"],
  setup(w) {
    const u = w, m = g(0), f = g(null);
    I(f, (e) => {
      m.value = e[0].contentRect.height;
    });
    const b = y("(max-width: 1120px)"), l = y("(max-width: 1000px)"), $ = T(() => `Guide / ${u.activePage?.title}`);
    return S(
      () => u.activePage?.uid,
      () => {
        const e = document.getElementById(P);
        e && (e.scrollTop = 0);
      }
    ), (e, a) => (d(), s("main", {
      id: t(P),
      ref_key: "documentEl",
      ref: f,
      class: n({
        [t(c).Document]: !0,
        "footer-below-sidebar": e.footerBelowSidebar,
        "hide-aside-right": t(b)
      }),
      style: p({ "--full-height": `${m.value}px` })
    }, [
      t(l) ? o("", !0) : (d(), s("div", z, [
        i(e.$slots, "header", {}, void 0, !0)
      ])),
      r("aside", {
        class: n(["layout-aside-left", t(c).Sidebar])
      }, [
        t(l) ? i(e.$slots, "mobile-header", {
          key: 0,
          label: $.value
        }, void 0, !0) : o("", !0),
        e.showSidebar || !t(l) ? (d(), s("div", O, [
          t(l) ? i(e.$slots, "header", { key: 0 }, void 0, !0) : o("", !0),
          i(e.$slots, "guide-sidebar", {}, void 0, !0)
        ])) : o("", !0)
      ], 2),
      e.activePage?.backgroundImage ? (d(), s("div", {
        key: 1,
        class: "layout-image",
        style: p(`background-image: url(${e.activePage.backgroundImage})`)
      }, null, 4)) : o("", !0),
      B(r("div", {
        class: n(["editor layout-content", t(N).Editor])
      }, [
        a[2] || (a[2] = E('<div class="section-flare-guide" data-v-4b6af3eb><div class="section-flare" data-v-4b6af3eb><div class="section-flare-item" data-v-4b6af3eb></div><div class="section-flare-item" data-v-4b6af3eb></div><div class="section-flare-item" data-v-4b6af3eb></div><div class="section-flare-item" data-v-4b6af3eb></div><div class="section-flare-item" data-v-4b6af3eb></div><div class="section-flare-item" data-v-4b6af3eb></div><div class="section-flare-item" data-v-4b6af3eb></div><div class="section-flare-item" data-v-4b6af3eb></div></div></div>', 1)),
        i(e.$slots, "editor-content", {}, void 0, !0),
        h(V, {
          activePage: e.activePage,
          sidebar: e.sidebar,
          onGoToNextPage: a[0] || (a[0] = (v) => e.$emit("goToNextPage", v)),
          onGoToPrevPage: a[1] || (a[1] = (v) => e.$emit("goToPrevPage", v))
        }, null, 8, ["activePage", "sidebar"]),
        r("div", {
          id: e.editorViewportId,
          class: "layout-content-viewport"
        }, null, 8, R)
      ], 2), [
        [C, e.isLoaded]
      ]),
      r("aside", L, [
        t(b) ? o("", !0) : (d(), s("div", {
          key: 0,
          class: n(["custom-scroll custom-scroll-self-contain-overflow", [t(c).TableOfContents]])
        }, [
          h(D, {
            headings: e.headings,
            pageTitle: e.activePage?.title || ""
          }, null, 8, ["headings", "pageTitle"])
        ], 2))
      ]),
      r("div", M, [
        i(e.$slots, "footer", {}, void 0, !0)
      ])
    ], 14, G));
  }
});
export {
  J as default
};
